<template>
    <div class="article_wrapper appear">

        <!-- Usually the Share.vue component -->
        <slot></slot>

        <article :class="articleClass" v-if="content">
            <div class="container">
                <div class="inner" data-appear="a1">

                    <div v-for="(item, i) in content"
                         class="content_type"
                         :class="getClasses(item)"
                         :key="i">

                        <template v-if="item.content_text">
                            <div v-html="item.content_text"></div>
                        </template>

                        <template v-if="item.content_image">
                            <img :src="item.content_image"
                                 @click="showFullImage(item.content_image)"/>
                        </template>

                        <template v-if="item.content_video">
                            <div class="play"
                                 @click="playVideo(item.content_video)">

                               <svg class="play play__icon" xmlns="http://www.w3.org/2000/svg" width="101" height="101" viewBox="0 0 101 101">
                                    <g fill="none" fill-rule="evenodd">
                                        <g>
                                            <g>
                                                <g transform="translate(-402 -1755) translate(227 1657) translate(175 98)">
                                                    <circle cx="50.4" cy="50.4" r="50.4" fill="#D8D8D8" opacity=".298"/>
                                                    <circle cx="50.4" cy="50.4" r="40" fill="#FFF"/>
                                                    <path stroke="#9E9E9E" stroke-width="1.2" d="M59.458 50.4L45.4 57.43V43.37l14.058 7.03z"/>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            </div>
                            <img
                                :src="`https://img.youtube.com/vi/${item.content_video}/0.jpg`"
                                class="preview"/>
                        </template>

                        <template v-if="item.content_link_label">
                            <div class="cta"  data-appear="a3">

                                <a :href="item.content_link_url"
                                   :target="item.content_link_target[0].value === 'content_link_target_blank' ? '_blank' : ''">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="12"
                                         viewBox="0 0 26 12">
                                        <g fill="none" fill-rule="evenodd">
                                            <g stroke="#FFF" stroke-width="1.5">
                                                <path d="M23.163 1.705L23.169 8.523 16.351 8.517"
                                                      transform="translate(-1713 -8200) translate(0 8031) translate(1120) translate(120 139) translate(473 31) rotate(-45 19.76 5.114)"/>
                                                <path d="M24.218 5.114L0 5.114"
                                                      transform="translate(-1713 -8200) translate(0 8031) translate(1120) translate(120 139) translate(473 31)"/>
                                            </g>
                                        </g>
                                    </svg>

                                    <span>{{item.content_link_label}}</span>
                                </a>
                            </div>
                        </template>


                    </div>
                </div>
            </div>

            <div class="overlay" v-if="overlayActive" @click="toggleOverlay">
                <div class="inner">
                    <div class="close"></div>
                    <iframe width="560" height="315"
                            :src="`https://www.youtube.com/embed/${activeVideoCode}`"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen v-if="overlayType === 'video'"></iframe>

                    <div class="picture" v-if="overlayType === 'image'">
                        <img :src="activeImgSrc"/>
                    </div>

                </div>
            </div>
        </article>
    </div>
</template>

<script>
    export default {
        name: "Article",
        data() {
            return {
                activeVideoCode: null,
                activeImgSrc: null,
                overlayActive: false,
                overlayType: null,
            }
        },
        props: {
            articleClass: {
                type: String,
                default: ''
            },
            content: {
                type: Array,
                default: () => [],
            }
        },
        methods: {
            // Embeded videos
            playVideo(code) {
                this.overlayActive = true;
                this.overlayType = 'video';
                this.activeVideoCode = code;
            },

            showFullImage(img) {
                this.overlayActive = true;
                this.overlayType = 'image';
                this.activeImgSrc = img;
            },

            toggleOverlay() {
                this.overlayActive = !this.overlayActive;
                this.activeVideoCode = null;
            },

            getClasses(item) {
                if (item.content_text) {
                    return `content_type-text ${item.content_text_alignment.value}`
                }
                if (item.content_image) {
                    return `content_type-image ${item.content_image_alignment.value}`
                }
                if (item.content_video) {
                    return `content_type-video ${item.content_video_alignment.value}`
                }
                if (item.content_link_label) {
                    return `content_type-link`
                }

            },
        }
    }
</script>

<style scoped>

</style>
